// ./utils/api-endpoints/employee.js

export const employeeEndpoints = {
    delete: '/api/Employee/Delete',
    getById: '/api/Employee/GetById',
    getEmployeeSummary: '/api/Employee/GetEmployeeSummary/{id}',
    getTeamsSummary: '/api/Employee/GetTeamsSummary/{id}',
    employeeType: '/api/Employee/EmployeeType',
    otherCompanies: '/api/Employee/OtherCompanies',
    getEmployeeForTeam: '/api/Employee/GetEmployeeForTeam/{id}',
    getEmployeeChartForTeam: '/api/Employee/GetEmployeeChartForTeam/{id}',
    isLower: '/api/Employee/IsLower',
    insert: '/api/Employee/Insert',
    filter: '/api/Employee/Filter',
    reportFilter: '/api/Employee/ReportFilter',
    filterAssigned: '/api/Employee/FilterAssigned',
    getAll: '/api/Employee/GetAll',
    getAllAssigned: '/api/Employee/GetAllAssigned',
    resetPassword: '/api/Employee/ResetPassword',
    verifyEmail: '/api/Employee/VerifyEmail',
    sendVerificationEmail: '/api/Employee/SendVerificationEmail',
    getAllAssignedEmpWithClientViewAll: '/api/Employee/GetAllAssignedEmpWithClientViewAll',
    update: '/api/Employee/Update',
    enforcePasswordChange: '/api/Employee/EnforcePasswordChange',
    enforcePasswordChangeAll: '/api/Employee/EnforcePasswordChangeAll',
    mobileUpdate: '/api/Employee/MobileUpdate',
    active: '/api/Employee/Active',
    UploadEmployeeFile: 'api/EmployeeFile/Upload' 
  };
  